module.exports = __webpack_public_path__ + "img/PromptPay-logo.96fb6db5.png";